import { Text } from 'react-native'
import { AlertMessage } from '.'
import { useTranslation } from 'react-i18next'
import { textColor } from '../../theme/colors'

interface Props {
  isRender: boolean
  action: () => void
}

export const Alert401 = ({ action, isRender }: Props) => {
  const { t } = useTranslation()

  if (!isRender) {
    return null
  }

  return (
    <AlertMessage title='ERROR' action={action}>
      <Text style={{ textAlign: 'center', color: textColor }}>
        {t('Su sesión ha expirado, debe ingresar nuevamente.')}
      </Text>
    </AlertMessage>
  )
}
